import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchHospitalListUsecase {
  constructor(private readonly hospitalManageRepository: HospitalRepository) {}

  async execute(): Promise<SATResult<HospitalInfoEntity[], SATError>> {
    const result = await this.hospitalManageRepository.getHospitalList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value);
  }
}
